//
//
//
//
//
//
//
//
//
//
//
//

import RbCommonModal from '@/elements/rox-panel/learn-more/common-modal/common-modal.vue'

export default {
  name: 'rb-rox-protection-plan',
  components: {
    RbCommonModal,
  },
}
